import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CompanyDashboardGet, IndicatorCreate, IndicatorGet, IndicatorUpdate, IndicatorVariableGet, OpportunityCreate, OpportunityGet, OpportunitySimpleGet, OpportunityUpdate, ProductCreate, ProductGet, ProductUpdate, SignalCreate, SignalGet, SignalUpdate } from '../interfaces/sales-engine-interfaces';
import { API_ROUTES } from './api-routes';
import { DEFAULT_JSON_HEADERS } from './headers.config';

@Injectable({
  providedIn: 'root'
})
export class SalesEngineService {
  constructor(private http: HttpClient) { }

  // INDICATOR

  getIndicatorVariables(): Observable<any> {
    const payload = {};

    return this.http.get<IndicatorVariableGet>(
      `${API_ROUTES.INDICATOR.VARIABLES}`,
      payload,
    );
  }

  getIndicators(): Observable<any> {
    const payload = {};

    return this.http.get<IndicatorGet[]>(
      `${API_ROUTES.INDICATOR.DEFAULT}`,
      payload,
    );
  }

  createIndicator(indicator: IndicatorCreate): Observable<any> {
    const payload = JSON.stringify(indicator);

    return this.http.post<IndicatorGet>(
      API_ROUTES.INDICATOR.DEFAULT,
      payload,
      { headers: DEFAULT_JSON_HEADERS }
    );
  }

  updateIndicator(id: string, indicator: IndicatorUpdate): Observable<any> {
    const payload = JSON.stringify(indicator);

    return this.http.post<IndicatorGet>(
      `${API_ROUTES.INDICATOR.DEFAULT}${id}`,
      payload,
      { headers: DEFAULT_JSON_HEADERS }
    );
  }

  deleteIndicator(id: string): Observable<any> {
    return this.http.delete<any>(
      `${API_ROUTES.INDICATOR.DEFAULT}${id}`
    );
  }

  // PRODUCT

  getProducts(): Observable<any> {
    const payload = {};

    return this.http.get<ProductGet[]>(
      `${API_ROUTES.PRODUCT.DEFAULT}`,
      payload,
    );
  }

  createProduct(product: ProductCreate): Observable<any> {
    const payload = JSON.stringify(product);

    return this.http.post<ProductGet>(
      API_ROUTES.PRODUCT.DEFAULT,
      payload,
      { headers: DEFAULT_JSON_HEADERS }
    );
  }

  updateProduct(id: string, product: ProductUpdate): Observable<any> {
    const payload = JSON.stringify(product);

    return this.http.post<ProductGet>(
      `${API_ROUTES.PRODUCT.DEFAULT}${id}`,
      payload,
      { headers: DEFAULT_JSON_HEADERS }
    );
  }

  deleteProduct(id: string): Observable<any> {
    return this.http.delete<any>(
      `${API_ROUTES.PRODUCT.DEFAULT}${id}`
    );
  }

  // SIGNAL

  getSignals(): Observable<any> {
    const payload = {};

    return this.http.get<SignalGet[]>(
      `${API_ROUTES.SIGNAL.DEFAULT}`,
      payload,
    );
  }

  getSignal(id: string): Observable<any> {
    const payload = {};

    return this.http.get<SignalGet>(
      `${API_ROUTES.SIGNAL.DEFAULT}${id}`,
      payload
    );
  }

  createSignal(signal: SignalCreate): Observable<any> {
    const payload = JSON.stringify(signal);

    return this.http.post<SignalGet>(
      API_ROUTES.SIGNAL.DEFAULT,
      payload,
      { headers: DEFAULT_JSON_HEADERS }
    );
  }

  updateSignal(id: string, signal: SignalUpdate): Observable<any> {
    const payload = JSON.stringify(signal);

    return this.http.post<SignalGet>(
      `${API_ROUTES.SIGNAL.DEFAULT}${id}`,
      payload,
      { headers: DEFAULT_JSON_HEADERS }
    );
  }

  deleteSignal(id: string): Observable<any> {
    return this.http.delete<any>(
      `${API_ROUTES.SIGNAL.DEFAULT}${id}`
    );
  }

  // OPPORTUNITY

  getOpportunities(): Observable<any> {
    const payload = {};

    return this.http.get<OpportunitySimpleGet[]>(
      `${API_ROUTES.OPPORTUNITY.DEFAULT}`,
      payload,
    );
  }

  getOpportunitiesFull(): Observable<any> {
    const payload = {};

    return this.http.get<OpportunityGet[]>(
      `${API_ROUTES.OPPORTUNITY.FULL}`,
      payload,
    );
  }

  getCompanyOpportunities(): Observable<any> {
    const payload = {};

    return this.http.get<CompanyDashboardGet[]>(
      `${API_ROUTES.OPPORTUNITY.COMPANY_OPPORTUNITIES}`,
      payload,
    );
  }

  getOpportunity(id: string): Observable<any> {
    const payload = {};

    return this.http.get<OpportunityGet>(
      `${API_ROUTES.OPPORTUNITY.DEFAULT}${id}`,
      payload
    );
  }

  createOpportunity(opportunity: OpportunityCreate): Observable<any> {
    const payload = JSON.stringify(opportunity);

    return this.http.post<OpportunityGet>(
      API_ROUTES.OPPORTUNITY.DEFAULT,
      payload,
      { headers: DEFAULT_JSON_HEADERS }
    );
  }

  updateOpportunity(id: string, opportunity: OpportunityUpdate): Observable<any> {
    const payload = JSON.stringify(opportunity);

    return this.http.post<OpportunityGet>(
      `${API_ROUTES.OPPORTUNITY.DEFAULT}${id}`,
      payload,
      { headers: DEFAULT_JSON_HEADERS }
    );
  }

  deleteOpportunity(id: string): Observable<any> {
    return this.http.delete<any>(
      `${API_ROUTES.OPPORTUNITY.DEFAULT}${id}`
    );
  }
}
